import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { MissingRequirementsModel } from '../models/missing-requirements.model';

@Injectable()
export class DocumentIncompleteIncidentService extends IncidentServiceBase<MissingRequirementsModel> {
    constructor() {
        super('MissingRequirement', () => new MissingRequirementsModel);
    }

    public getLookups() {
        return this.get('Incident/MissingRequirement/lookups');
    }
}
